module.exports = __webpack_public_path__ + "media/images/icon__profile@2x-7d794beb079478d74cd9f1076fb7eaad.png";